import { gql } from "@apollo/client";

export const QUERY_LOAD_DETAIL = gql`
  query Load($id: ID!) {
    load(id: $id) {
      timePosted
      modfied
      id
      originAddress
      destinationAddress
      originCity
      destinationCity
      originState
      destinationState
      originCountry
      destinationCountry
      originIso2
      originIso3
      destinationIso2
      destinationIso3
      originZip
      originAreacode
      destinationZip
      destinationAreacode
      trailerType
      length
      weight
      targetRate
      timeStart
      timeEnd
      timeDelivery
      matchDate
      details
      recentBid
      linehaulRate
      linehaulDistance
      linehaulDuration
      linehaulRoute
      costPerMile
      linehaulCpm
      cargoValue
      userLoadNumber
      isDeleted
      isRateIndex
      originLocations
      destinationLocations
      attachments
      userType
      postTo
      groups
      groupsPostTo
      status
      modified
      created
      loadId
      originCoords {
        latitude
        longitude
      }
      destinationCoords {
        latitude
        longitude
      }
      user {
        id
        email
        userType
        contactName
        contactEmail
        address
        city
        state
        country
        contactPhone
        mc
        dot
      }
      bids {
        id
        amount
        bidStatus
        hasBeenUnderBid
        bidderNotes
        modified
        created
        acceptedBy {
          id
          email
          userType
          contactName
          contactEmail
          city
          state
          country
          contactPhone
          mc
          dot
        }
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
      }
      assignedUser {
        id
        email
        userType
        contactName
        contactEmail
        city
        state
        country
        contactPhone
        mc
        dot
      }
    }
  }
`;

export const QUERY_LOAD_QUESTION = gql`
  query LoadQuestions($loadId: UUID!) {
    loadQuestions(loadId: $loadId) {
      data {
        timePosted
        id
        question
        user
        rawId
        loadId
        answerSet {
          timePosted
          id
          answer
        }
      }
    }
  }
`;

export const MUTATION_SAVED_LOAD = gql`
  mutation CreateUserSavedLoad($loadId: UUID!) {
    createUserSavedLoad(loadId: $loadId) {
      userSavedLoad {
        id
      }
    }
  }
`;

export const MUTATION_CREATE_BID = gql`
  mutation CreateBid($loadId: ID!, $amount: Float!, $bidderNotes: String) {
    createBid(input: { loadId: $loadId, amount: $amount, bidderNotes: $bidderNotes }) {
      bid {
        id
        amount
        bidStatus
        hasBeenUnderBid
        bidderNotes
        modified
        created
      }
    }
  }
`;

export const MUTATION_DELETE_BID = gql`
  mutation DeleteBid($bidId: UUID!) {
    deleteBid(bidId: $bidId) {
      success
    }
  }
`;

export const MUTATION_ACCEPT_BID = gql`
  mutation AcceptBid($bidId: UUID!) {
    acceptBid(bidId: $bidId) {
      bid {
        id
        amount
        bidStatus
        hasBeenUnderBid
        bidderNotes
        modified
        created
        acceptedBy {
          id
          email
          userType
          contactName
          contactEmail
          city
          state
          country
          contactPhone
          mc
          dot
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_BID = gql`
  mutation UpdateBid($bidId: ID!, $amount: Int!, $bidderNotes: String) {
    updateBid(input: { bidId: $bidId, amount: $amount, bidderNotes: $bidderNotes }) {
      bid {
        id
        amount
        bidStatus
        hasBeenUnderBid
        bidderNotes
        modified
        created
      }
    }
  }
`;

export const MUTATION_CREATE_LOAD_QUESTION = gql`
  mutation CreateLoadQuestion($question: String!, $loadId: UUID!) {
    createLoadQuestion(question: $question, loadId: $loadId) {
      question {
        timePosted
        id
        question
        user
        rawId
        loadId
        answerSet {
          timePosted
          id
          answer
        }
      }
    }
  }
`;

export const MUTATION_CREATE_LOAD_ANSWER = gql`
  mutation CreateLoadAnswer($answer: String!, $loadId: String!, $questionId: String!) {
    createLoadAnswer(answer: $answer, loadId: $loadId, questionId: $questionId) {
      answer {
        timePosted
        id
        answer
        loadId
        questionId
      }
    }
  }
`;
